export enum UserProfiles {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  INSTITUCION = 'institucion',
  MEDICO = 'medico',
  DISTRIBUIDOR = 'distribuidor',
}

export enum UserCompany {
  PAMPAMED = 'Pampamed',
  SCANMED = 'Scanmed'
}
